// // ============================================================
// // src/components/Gallery.js
// // ============================================================
// import React from "react";

// const galleryItems = [
//   { emoji: "🏥", bg: "linear-gradient(135deg,#0a1628,#1a3a6b)", cls: "span2", label: "Reception & Lobby" },
//   { emoji: "🦷", bg: "linear-gradient(135deg,#0d7377,#14a0a5)", cls: "", label: "Treatment Room" },
//   { emoji: "💺", bg: "linear-gradient(135deg,#8b6914,#c9a84c)", cls: "r2", label: "Dental Suite" },
//   { emoji: "🔬", bg: "linear-gradient(135deg,#1e3a5f,#2a5298)", cls: "", label: "Digital X-Ray Lab" },
//   { emoji: "😁", bg: "linear-gradient(135deg,#0a1628,#0d7377)", cls: "", label: "Smile Gallery" },
//   { emoji: "👶", bg: "linear-gradient(135deg,#5b3a8b,#9b59b6)", cls: "", label: "Kids' Zone" },
// ];

// export default function Gallery() {
//   return (
//     <section className="gallery" id="gallery">
//       <div className="gallery-header">
//         <div className="section-tag">Our Clinic</div>
//         <h2 className="section-title">A Calm &amp; <em>Healing Space</em></h2>
//         <p className="section-desc" style={{ margin: "0 auto" }}>
//           Designed for comfort and confidence — our clinic is equipped with the latest technology
//           in a warm, welcoming environment.
//         </p>
//       </div>
//       <div className="gallery-grid">
//         {galleryItems.map((g, i) => (
//           <div
//             key={i}
//             className={`gallery-item ${g.cls}`}
//             style={{ background: g.bg, flexDirection: "column", gap: 8 }}
//           >
//             <span style={{ fontSize: g.cls === "span2" ? 72 : 48 }}>{g.emoji}</span>
//             <span style={{ color: "rgba(255,255,255,0.7)", fontSize: 13 }}>{g.label}</span>
//           </div>
//         ))}
//       </div>
//     </section>
//   );
// }

// ============================================================
// src/components/Gallery.js
// ✅ Specialty-aware gallery items
// ============================================================
import React from "react";
import { useHospital } from "../context/HospitalContext";

const SPECIALTY_GALLERY = {
  dental: [
    {
      emoji: "🏥",
      bg: "linear-gradient(135deg,#0a1628,#1a3a6b)",
      cls: "span2",
      label: "Reception & Lobby",
    },
    {
      emoji: "🦷",
      bg: "linear-gradient(135deg,#0d7377,#14a0a5)",
      cls: "",
      label: "Treatment Room",
    },
    {
      emoji: "💺",
      bg: "linear-gradient(135deg,#8b6914,#c9a84c)",
      cls: "r2",
      label: "Dental Suite",
    },
    {
      emoji: "🔬",
      bg: "linear-gradient(135deg,#1e3a5f,#2a5298)",
      cls: "",
      label: "Digital X-Ray Lab",
    },
    {
      emoji: "😁",
      bg: "linear-gradient(135deg,#0a1628,#0d7377)",
      cls: "",
      label: "Smile Gallery",
    },
    {
      emoji: "👶",
      bg: "linear-gradient(135deg,#5b3a8b,#9b59b6)",
      cls: "",
      label: "Kids' Zone",
    },
  ],

  ayurved: [
    {
      emoji: "🌿",
      bg: "linear-gradient(135deg,#1a3a2a,#2d6a4f)",
      cls: "span2",
      label: "Reception & Lobby",
    },
    {
      emoji: "🫧",
      bg: "linear-gradient(135deg,#1b4332,#40916c)",
      cls: "",
      label: "Panchakarma Suite",
    },
    {
      emoji: "🪔",
      bg: "linear-gradient(135deg,#7b4f00,#c9a84c)",
      cls: "r2",
      label: "Consultation Room",
    },
    {
      emoji: "🌸",
      bg: "linear-gradient(135deg,#4a1040,#9b2d6f)",
      cls: "",
      label: "Herbal Pharmacy",
    },
    {
      emoji: "🧘",
      bg: "linear-gradient(135deg,#0d3b5e,#1a6a9a)",
      cls: "",
      label: "Yoga & Meditation Hall",
    },
    {
      emoji: "💆",
      bg: "linear-gradient(135deg,#3d1f00,#8b5e3c)",
      cls: "",
      label: "Abhyanga Therapy Room",
    },
  ],

  ortho: [
    {
      emoji: "🏥",
      bg: "linear-gradient(135deg,#0a1628,#1a3a6b)",
      cls: "span2",
      label: "Reception & Lobby",
    },
    {
      emoji: "🦴",
      bg: "linear-gradient(135deg,#1a3a6b,#2a5298)",
      cls: "",
      label: "Orthopedic OPD",
    },
    {
      emoji: "🏋️",
      bg: "linear-gradient(135deg,#0d4f3a,#1a8a65)",
      cls: "r2",
      label: "Physiotherapy & Rehab",
    },
    {
      emoji: "🔬",
      bg: "linear-gradient(135deg,#1e3a5f,#2a5298)",
      cls: "",
      label: "Digital Imaging Lab",
    },
    {
      emoji: "🧬",
      bg: "linear-gradient(135deg,#4a0e4e,#8b2fc9)",
      cls: "",
      label: "Operation Theatre",
    },
    {
      emoji: "🛏️",
      bg: "linear-gradient(135deg,#0a1628,#0d4f3a)",
      cls: "",
      label: "Recovery Ward",
    },
  ],

  eye: [
    {
      emoji: "🏥",
      bg: "linear-gradient(135deg,#0a1628,#1a3a6b)",
      cls: "span2",
      label: "Reception & Lobby",
    },
    {
      emoji: "👁️",
      bg: "linear-gradient(135deg,#0d3b5e,#1a6a9a)",
      cls: "",
      label: "Eye Examination Suite",
    },
    {
      emoji: "✨",
      bg: "linear-gradient(135deg,#1e3a5f,#2a5298)",
      cls: "r2",
      label: "LASIK Suite",
    },
    {
      emoji: "🔬",
      bg: "linear-gradient(135deg,#0d4f3a,#1a8a65)",
      cls: "",
      label: "Retina Imaging Lab",
    },
    {
      emoji: "🏆",
      bg: "linear-gradient(135deg,#8b6914,#c9a84c)",
      cls: "",
      label: "Cataract OT",
    },
    {
      emoji: "👶",
      bg: "linear-gradient(135deg,#5b3a8b,#9b59b6)",
      cls: "",
      label: "Paediatric Eye Zone",
    },
  ],

  cardiology: [
    {
      emoji: "🏥",
      bg: "linear-gradient(135deg,#0a1628,#1a3a6b)",
      cls: "span2",
      label: "Reception & Lobby",
    },
    {
      emoji: "❤️",
      bg: "linear-gradient(135deg,#7b0000,#c0392b)",
      cls: "",
      label: "Cardiac OPD",
    },
    {
      emoji: "⚡",
      bg: "linear-gradient(135deg,#1e3a5f,#2a5298)",
      cls: "r2",
      label: "Cath Lab",
    },
    {
      emoji: "🔬",
      bg: "linear-gradient(135deg,#0d4f3a,#1a8a65)",
      cls: "",
      label: "Echocardiography Lab",
    },
    {
      emoji: "🧬",
      bg: "linear-gradient(135deg,#4a0e4e,#8b2fc9)",
      cls: "",
      label: "Cardiac Surgery OT",
    },
    {
      emoji: "🛏️",
      bg: "linear-gradient(135deg,#0a1628,#0d4f3a)",
      cls: "",
      label: "Cardiac ICU (CICU)",
    },
  ],

  pediatric: [
    {
      emoji: "🏥",
      bg: "linear-gradient(135deg,#0a1628,#1a3a6b)",
      cls: "span2",
      label: "Reception & Lobby",
    },
    {
      emoji: "🧸",
      bg: "linear-gradient(135deg,#5b3a8b,#9b59b6)",
      cls: "",
      label: "Paediatric OPD",
    },
    {
      emoji: "🎨",
      bg: "linear-gradient(135deg,#c9a84c,#8b6914)",
      cls: "r2",
      label: "Kids' Waiting Zone",
    },
    {
      emoji: "🍼",
      bg: "linear-gradient(135deg,#0d4f3a,#1a8a65)",
      cls: "",
      label: "Neonatal ICU (NICU)",
    },
    {
      emoji: "💉",
      bg: "linear-gradient(135deg,#1e3a5f,#2a5298)",
      cls: "",
      label: "Vaccination Suite",
    },
    {
      emoji: "🛏️",
      bg: "linear-gradient(135deg,#0a1628,#0d4f3a)",
      cls: "",
      label: "Paediatric Ward",
    },
  ],

  general: [
    {
      emoji: "🏥",
      bg: "linear-gradient(135deg,#0a1628,#1a3a6b)",
      cls: "span2",
      label: "Reception & Lobby",
    },
    {
      emoji: "🩺",
      bg: "linear-gradient(135deg,#0d4f3a,#1a8a65)",
      cls: "",
      label: "General Medicine OPD",
    },
    {
      emoji: "🔬",
      bg: "linear-gradient(135deg,#1e3a5f,#2a5298)",
      cls: "r2",
      label: "Diagnostics & Lab",
    },
    {
      emoji: "🧬",
      bg: "linear-gradient(135deg,#4a0e4e,#8b2fc9)",
      cls: "",
      label: "Operation Theatre",
    },
    {
      emoji: "🛏️",
      bg: "linear-gradient(135deg,#0a1628,#0d4f3a)",
      cls: "",
      label: "General Ward",
    },
    {
      emoji: "🚑",
      bg: "linear-gradient(135deg,#7b0000,#c0392b)",
      cls: "",
      label: "Emergency & Casualty",
    },
  ],
};

export default function Gallery() {
  const { hospital } = useHospital();
  const type = (hospital?.type || "dental").toLowerCase();
  const items = SPECIALTY_GALLERY[type] || SPECIALTY_GALLERY.dental;

  return (
    <section className="gallery" id="gallery">
      <div className="gallery-header">
        <div className="section-tag">Our Facility</div>
        <h2 className="section-title">
          A Calm &amp; <em>Healing Space</em>
        </h2>
        <p className="section-desc" style={{ margin: "0 auto" }}>
          Designed for comfort and confidence — our facility is equipped with
          the latest technology in a warm, welcoming environment.
        </p>
      </div>
      <div className="gallery-grid">
        {items.map((g, i) => (
          <div
            key={i}
            className={`gallery-item ${g.cls}`}
            style={{ background: g.bg, flexDirection: "column", gap: 8 }}
          >
            <span style={{ fontSize: g.cls === "span2" ? 72 : 48 }}>
              {g.emoji}
            </span>
            <span style={{ color: "rgba(255,255,255,0.7)", fontSize: 13 }}>
              {g.label}
            </span>
          </div>
        ))}
      </div>
    </section>
  );
}
